<!-- Skeleton Process Setup - Responsive -->
<div class="flex flex-col flex-1 h-full min-h-0 w-full gap-4 sm:gap-6 lg:gap-8 xl:flex-row xl:gap-8 2xl:gap-12">

  <!-- Main content skeleton -->
  <div class="flex flex-1 flex-col gap-4 sm:gap-6">
    <!-- Page container skeleton -->
    <div
      class="flex flex-col gap-3 sm:gap-4 p-4 sm:p-6 bg-white rounded-md border border-[var(--colors-gray-scale-gray-4)]"
    >
      <!-- Title skeleton -->
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
        <p-skeleton
          width="160px"
          height="24px"
          borderRadius="4px"
          class="sm:w-[180px] sm:h-[28px]"
        />
        <p-skeleton
          width="100px"
          height="20px"
          borderRadius="4px"
          class="sm:w-[120px]"
        />
      </div>

      <!-- Table skeleton -->
      <div class="flex flex-col gap-2 sm:gap-3">
        <!-- Table header skeleton -->
        <div
          class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 p-3 sm:p-4 bg-gray-50 rounded border border-[var(--colors-gray-scale-gray-4)]"
        >
          <!-- Mobile: Stack verticale -->
          <div class="block sm:hidden space-y-2">
            <p-skeleton
              width="120px"
              height="16px"
              borderRadius="4px"
            />
          </div>

          <!-- Tablet e Desktop: Griglia -->
          <div class="hidden sm:flex sm:items-center sm:gap-4 flex-1">
            <p-skeleton
              width="150px"
              height="20px"
              borderRadius="4px"
              class="lg:w-[200px]"
            />
            <p-skeleton
              width="120px"
              height="20px"
              borderRadius="4px"
              class="lg:w-[150px]"
            />
            <p-skeleton
              width="100px"
              height="20px"
              borderRadius="4px"
              class="lg:w-[120px]"
            />
            <p-skeleton
              width="80px"
              height="20px"
              borderRadius="4px"
              class="lg:w-[100px]"
            />
          </div>
        </div>

        <!-- Table rows skeleton -->
        <div
          *ngFor="let item of [1,2,3,4,5]; trackBy: trackByIndex"
          class="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 p-3 sm:p-4 border border-[var(--colors-gray-scale-gray-4)] rounded"
        >
          <!-- Mobile: Layout a card -->
          <div class="block sm:hidden space-y-2">
            <p-skeleton
              width="140px"
              height="16px"
              borderRadius="4px"
            />
            <p-skeleton
              width="100px"
              height="16px"
              borderRadius="4px"
            />
            <div class="flex justify-between items-center">
              <p-skeleton
                width="60px"
                height="16px"
                borderRadius="4px"
              />
              <p-skeleton
                width="60px"
                height="28px"
                borderRadius="6px"
              />
            </div>
          </div>

          <!-- Tablet e Desktop: Griglia -->
          <div class="hidden sm:flex sm:items-center sm:gap-4 flex-1">
            <p-skeleton
              width="150px"
              height="20px"
              borderRadius="4px"
              class="lg:w-[200px]"
            />
            <p-skeleton
              width="120px"
              height="20px"
              borderRadius="4px"
              class="lg:w-[150px]"
            />
            <p-skeleton
              width="100px"
              height="20px"
              borderRadius="4px"
              class="lg:w-[120px]"
            />
            <p-skeleton
              width="60px"
              height="28px"
              borderRadius="6px"
              class="lg:w-[80px] lg:h-[32px]"
            />
          </div>
        </div>
      </div>

      <!-- Pagination skeleton -->
      <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 pt-3 sm:pt-4 ">
        <p-skeleton
          width="100px"
          height="18px"
          borderRadius="4px"
          class="sm:w-[120px] sm:h-[20px]"
        />
        <div class="flex items-center justify-center sm:justify-end gap-2">
          <p-skeleton
            width="28px"
            height="28px"
            borderRadius="6px"
            class="sm:w-[32px] sm:h-[32px]"
          />
          <p-skeleton
            width="28px"
            height="28px"
            borderRadius="6px"
            class="sm:w-[32px] sm:h-[32px]"
          />
          <p-skeleton
            width="28px"
            height="28px"
            borderRadius="6px"
            class="sm:w-[32px] sm:h-[32px]"
          />
          <p-skeleton
            width="28px"
            height="28px"
            borderRadius="6px"
            class="sm:w-[32px] sm:h-[32px]"
          />
        </div>
      </div>
    </div>
  </div>
</div>